export const getFormattedTime = (today: Date) => {
  const y = today.getFullYear();
  const m = today.getMonth() + 1;
  const d = today.getDate();
  return `${y}-${m}-${d}`;
};
